import { ReactElement } from 'react';
import { Stack, Typography } from '@mui/material';

import MultipleLinearProgresBar from '~components/MultipleLinearProgresBar';
import { toAbsoluteUrl } from '~utils/assetsHelpers';

// eslint-disable-next-line max-len
import { DashboardVariantV2CarrierHeaderLogoImg } from '../../../../../../Header/SubComponents/styles';

import { useDashboardVariantV2CarrierContentInTransitTrackingContext } from '../Context';
import DashboardVariantV2CarrierContentInTransitTabTrackingSelectionTabs from './Tabs';

import { DashboardVariantV2CarrierContentInTransitTabTrackingSelectionContainer } from './styles';

const DashboardVariantV2CarrierContentInTransitTabTrackingSelection =
  (): ReactElement => {
    const {
      tabsData: { data: tabsData },
    } = useDashboardVariantV2CarrierContentInTransitTrackingContext();

    return (
      <DashboardVariantV2CarrierContentInTransitTabTrackingSelectionContainer>
        <Stack spacing={1.5}>
          <Typography variant="h5">
            <strong>{tabsData?.totalItemsInProgress ?? 0}</strong> Pedidos en
            viaje
          </Typography>

          <MultipleLinearProgresBar
            items={[
              {
                label: 'Envíos estándar',
                value: tabsData?.totalItemsInProgressNoFlex ?? 0,
                color: '#5618B6',
                customDot: (
                  <DashboardVariantV2CarrierHeaderLogoImg
                    src={toAbsoluteUrl('/logo_minimal.svg')}
                    alt="Routix Icon"
                  />
                ),
              },
              {
                label: 'Envíos Flex',
                value: tabsData?.totalItemsInProgressFlex ?? 0,
                color: '#FFEB00',
                customDot: (
                  <DashboardVariantV2CarrierHeaderLogoImg
                    src={toAbsoluteUrl('/images/icon_source_mp@2x.png')}
                    alt="MercadoPago Icon"
                  />
                ),
              },
            ]}
            size="medium"
            showTotal={false}
            showLegend
          />
        </Stack>

        <DashboardVariantV2CarrierContentInTransitTabTrackingSelectionTabs />
      </DashboardVariantV2CarrierContentInTransitTabTrackingSelectionContainer>
    );
  };

export default DashboardVariantV2CarrierContentInTransitTabTrackingSelection;
